import { AppContext } from "@/contextApi/AppProvider";
import { AppContextType } from "@/interFace/general";
import Link from "next/link";
import React, { useContext } from "react";
import Logo from "../../../../public/assets/img/logo/logo.png";
import Image from "next/image";
import MemoMenuTwo from "./MemoMenuTwo";
import { useTranslations } from "next-intl";
import { Translations } from "@/translations";

const MemoMobileMenu = () => {
  const { toggleSideMenu, sideMenuOpen, locale } = useContext(
    AppContext
  ) as AppContextType;
  const t = useTranslations("General");

  return (
    <div className={sideMenuOpen ? "sidebar__area open" : "sidebar__area"}>
      <div className="sidebar__wrapper">
        <div className="sidebar__close">
          <button
            className="sidebar__close-btn"
            onClick={toggleSideMenu}
            id="sidebar__close-btn"
          >
            <span>
              <i className="fal fa-times"></i>
            </span>
            <span>{t(Translations.General.Close)}</span>
          </button>
        </div>
        <div className="sidebar__content">
          <div className="logo mb-40">
            <Link href="/">
              <Image
                style={{ width: "96px", height: "auto" }}
                src={Logo}
                alt="logo"
              />
            </Link>
          </div>
          <div className="mm-menu">
            <ul>
              <MemoMenuTwo />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemoMobileMenu;
